import React from 'react';
import '../styles/legal-page.css'; // Ensure the correct CSS is applied
import { Link } from 'react-router-dom';
import Footer from '../components/Footer'; // Import the Footer component

const TermsOfService: React.FC = () => {
  return (
    <div className="legal-page-container">
      {/* Clickable Dog Image - redirects to homepage */}
      <div className="centered-image-container">
        <Link to="/">
          <img
            src={`${process.env.PUBLIC_URL}/curios-dog.jpeg`}
            alt="Curious Dog"
            className="circle-dog-image" 
          />
        </Link>
      </div>

      <div className="legal-content-container">
        <div className="content">
          <h1>Terms of Service</h1>
          <p>Welcome to Curios.dog. By using our site, you agree to the following terms and conditions. Please read them carefully.</p>

          <h2 className="legal-section-title">1. Acceptance of Terms</h2>
          <p>By accessing and using Curios.dog, you accept and agree to be bound by these Terms of Service. If you do not agree to these terms, you are prohibited from using our website.</p>

          <h2 className="legal-section-title">2. Description of Service</h2>
          <p>
            Curios.dog provides a platform for users to ask and answer questions anonymously. We do not guarantee the accuracy, integrity, or quality of any content posted on the platform. Your use of the service is at your own risk.
          </p>

          <h2 className="legal-section-title">3. User Conduct</h2>
          <p>You agree not to use Curios.dog to post, share, or transmit any content that:</p>
          <ul>
            <li>Is illegal, harmful, threatening, abusive, or harassing.</li>
            <li>Contains any harmful or malicious software (viruses, worms, etc.).</li>
            <li>Violates the privacy rights or other rights of individuals.</li>
            <li>Encourages behavior that could be considered illegal or inappropriate.</li>
          </ul>

          <h2 className="legal-section-title">4. Privacy</h2>
          <p>
            Your privacy is important to us. Please refer to our <a href="/privacy-policy">Privacy Policy</a> for details on how we collect, use, and protect your personal information.
          </p>

          <h2 className="legal-section-title">5. Content Ownership</h2>
          <p>
            All content posted on Curios.dog remains the property of the original author. However, by posting content on the platform, you grant us a non-exclusive, royalty-free, perpetual, and irrevocable license to use, modify, distribute, and display the content in connection with our services.
          </p>

          <h2 className="legal-section-title">6. Beta Experimental Phase Disclaimer</h2>
          <p>
            Curios.dog is currently in a beta experimental phase. As a result, certain features may not function as expected, and users may experience intermittent issues, including data loss or temporary service interruptions. By using the platform during this phase, you acknowledge and accept these potential risks.
          </p>
          <p>
            We recommend users back up any important content, as Curios.dog does not guarantee the integrity or retention of data during this phase. The platform may undergo significant updates and changes during this period to improve functionality and stability.
          </p>

          <h2 className="legal-section-title">7. Termination</h2>
          <p>
            We reserve the right to terminate or suspend your access to Curios.dog at any time for any reason, including but not limited to violations of these Terms of Service.
          </p>

          <h2 className="legal-section-title">8. Changes to Terms</h2>
          <p>We may modify these Terms of Service at any time. We will notify users of significant changes through the site or via email. Your continued use of Curios.dog constitutes acceptance of any changes.</p>

          <h2 className="legal-section-title">9. Disclaimer of Warranties</h2>
          <p>
            Curios.dog is provided "as is" without warranties of any kind, either express or implied. We do not warrant that the service will be uninterrupted, secure, or error-free, or that any content will be accurate or reliable.
          </p>

          <h2 className="legal-section-title">10. Limitation of Liability</h2>
          <p>
            In no event shall Curios.dog be liable for any indirect, incidental, or consequential damages arising out of your use or inability to use the service.
          </p>

          <h2 className="legal-section-title">11. Contact Information</h2>
          <p>If you have any questions about these Terms of Service, please contact us at support@curios.dog.</p>
        </div>

        <div className="join-waitlist-container">
          <button className="join-waitlist-btn" onClick={() => window.location.href = "/join"}>
            Join The Waiting List
          </button>
        </div>
      </div>

      <Footer /> {/* Add the Footer at the bottom of the page */}
    </div>
  );
};

export default TermsOfService;
